<template>
  <div id="content" class="startup_page">
    <AddToListModal  :dialogVisible='dialoglist'  @close="dialoglist = false" @toExisting="toExisting($event)"></AddToListModal>
    <CreateListModal  :dialogVisible='dialogCreateList'  @close="dialogCreateList = false" @createList="createList($event)"></CreateListModal>
    <ConfirmModal :dialogVisible='dialogRevoke' @close="dialogRevoke = false" @confirmed="revokeAccess($event)" message="Are you sure ? This action can't be canceled." ></ConfirmModal>
    <ConfirmModal :dialogVisible='dialogRemove' @close="dialogRemove = false" @confirmed="removeStartup($event)" message="Are you sure ? This action can't be canceled." ></ConfirmModal>
    <StartupRunAssessment @close="runassessment=false" :dialogVisible="runassessment"
     @newInternal="newInternal"
     @newInnopearl="newInnopearl"
     @existingInternal="existingInternal">
    </StartupRunAssessment>
      <div class="content_div stats">
        <div class="sidePannel" v-if="showSidePanelBasic == true">

          <div class="filters">


            <div class="oneFilter" v-for="(filtre,f) in basicFilters" :key="f">
              <span class="filtreName clickable" @click="filtre.toggled_sidebar = !filtre.toggled_sidebar">
                {{filtre.display_name}}<span v-if="filtre.key =='revenue' ">(millions)</span>
                <sup class="nb_item" v-if="filtre.values.length > 0">{{filtre.values.length}}</sup>
                <sup class="nb_item" v-else-if="filtre.values.min > 0 || filtre.values.max > 0">1</sup>
                <sup class="nb_item" v-else-if="filtre.values.from || filtre.values.to">1</sup>

                <img :src="require('@/assets/triangle.svg')" class="triangle" :class='(filtre.toggled_sidebar == true) ? "open" : "not-open"' alt="">
              </span>
              <div v-if="filtre.toggled_sidebar == true">
                <div class="" v-if="filtre.key =='submitDate' ">
                  <div class="moneyEntryLine">
                    <span class="moneyEntryName">From </span><input class="moneyEntryInput input_filtre" type="date" v-model="filtre.values.from"/>
                  </div>
                  <div class="moneyEntryLine">
                    <span class="moneyEntryName">To </span> <input class="moneyEntryInput input_filtre" type="date" v-model="filtre.values.to"/>
                  </div>
                </div>
              <div class="" v-else-if="filtre.key =='revenue' ">
                  <div class="moneyEntryLine">
                    <span class="moneyEntryName">From </span><input class="moneyEntryInput input_filtre" type="number" v-model="filtre.values.min"/>
                  </div>
                  <div class="moneyEntryLine">
                    <span class="moneyEntryName">To </span> <input class="moneyEntryInput input_filtre" type="number" v-model="filtre.values.max"/>
                  </div>

                  <!-- <div class="moneyEntryLine">
                    <span class="moneyEntryName">Currency </span>
                    <select class="moneyEntryInput input_filtre" name=""  v-model="filtre.values.devise">
                      <option value="EUR">EUR</option>
                      <option value="USD">USD</option>
                      <option value="CHF">CHF</option>
                    </select>
                </div> -->


              </div>
              <div class="" v-else-if="filtre.key =='linkplus' ">
              <input type="text" class="input_filtre" name="" placeholder="Search" v-model="filtre.filtre">

              <div class="value_possible">
                <label class="checkbox"  v-for="(val,v) in filtre.values_list" :key="v">
                  <div class="checkboxItem"  v-if="val.name.toUpperCase().includes(filtre.filtre.toUpperCase())">


                    <input class="checkbox__input" type="checkbox" v-model="filtre.values" :value="val._id.$oid"/>
                    <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                      <rect width="21" height="21" x=".5" y=".5" fill="#FFF" stroke="#3783C5" rx="3" />
                      <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                    </svg>
                    <span class="checkbox__label">{{val.name}}</span>
                          </div>
                  </label>

              </div>
            </div>
              <div class="" v-else>
              <input type="text" class="input_filtre" name="" placeholder="Search" v-model="filtre.filtre">

              <div class="value_possible">
                <label class="checkbox"  v-for="(val,v) in filtre.values_list.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)" :key="v">
                  <div class="checkboxItem"  v-if="val.value.toUpperCase().includes(filtre.filtre.toUpperCase())">


                    <input class="checkbox__input" type="checkbox" v-model="filtre.values" :value="val.value"/>
                    <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                      <rect width="21" height="21" x=".5" y=".5" fill="#FFF" stroke="#3783C5" rx="3" />
                      <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                    </svg>
                    <span class="checkbox__label">{{val.name}}</span>
                          </div>
                  </label>

              </div>
            </div>
            </div>
            </div>
          </div>
          <div class="footerPannel">
              <button type="button" name="button" class="btn_invert" @click="showSidePanelBasic = false">Close</button>
              <button type="button" @click="reset_bfilter()" class="btn_invert" name="button">Reset filters</button>

              <button type="button" @click="apply_filter()" class="btn" name="button">Apply filters</button>
          </div>

        </div>
        <div class="row   " >
          <div class="col-12">

            <div class="poolTitle">
              <h2 class="customH2 text-center">Manage innovators
            </h2>
            </div>


          <div class="col-12  dflex" >
            <div class="col-12 col-12 startup_selection_section">


            <div class="super_action_zone mt30">

                <div class="quicksearch">
                      <input type="text" class="input" placeholder="Search by name"  v-model="quicksearch">
                </div>
                <div class="tooglerFilter">
                  <div class="toogler" @click="showSidePanelBasic = !showSidePanelBasic">
                      FILTER
                      <small class="nb_item" v-if="basicFilters.filter(obj => ((Array.isArray(obj.values) && obj.values.length > 0) || (obj.values.min > 0 || obj.values.max > 0) || (obj.values.from || obj.values.to))).length  > 0">{{basicFilters.filter(obj => ((Array.isArray(obj.values) && obj.values.length > 0) || (obj.values.min > 0 || obj.values.max > 0) || (obj.values.from || obj.values.to))).length  }}</small>
                      <img :src="require('@/assets/filter2024.svg')" class="" alt="">
                  </div>
                </div>



                </div>
          </div>
            <!-- <div class="col-12 col-12 startup_selection_section">


            <div class="super_action_zone">

            <div class="filtre_list_2">



              <div v-for="(filtre,f) in basicFilters.slice(0,4)" :key="f">
                <div class="vselect_container" >
                  <div class="zone_input">
                    <div class="zone_input_header" @click="toggleFilter(filtre.key)">
                      <span class="zone_input_name">{{filtre.display_name}}<span v-if="filtre.key =='revenue' ">(millions)</span>

                        <small class="nb_item" v-if="filtre.values.length > 0">{{filtre.values.length}}</small>
                        <img :src="require('@/assets/triangle.svg')" class="triangle" :class='(filtre.toggled == true) ? "open" : "not-open"' alt=""></span>

                    </div>

                    <div class="filter_content" v-if='filtre.toggled == true'>
                      <div class="value_possible" v-if="filtre.key == 'linkplus'">
                        <input type="text" class="input_filtre" name="" placeholder="Search" v-model="filtre.filtre">
                        <label class="checkbox"  v-for="(val,v) in filtre.values_list.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) " :key="v">
                          <div class="checkboxItem" v-if="val.name.toUpperCase().includes(filtre.filtre.toUpperCase())">


                            <input class="checkbox__input" type="checkbox" v-model="filtre.values" :value="val._id.$oid"/>
                            <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                              <rect width="21" height="21" x=".5" y=".5" fill="#FFF" stroke="#3783C5" rx="3" />
                              <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                            </svg>
                            <span class="checkbox__label">{{val.name}}</span>
                                  </div>
                          </label>

                      </div>
                      <div class="value_possible" v-else>
                        <input type="text" class="input_filtre" name="" placeholder="Search" v-model="filtre.filtre">
                        <label class="checkbox"  v-for="(val,v) in filtre.values_list.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) " :key="v">
                          <div class="checkboxItem" v-if="val.value.toUpperCase().includes(filtre.filtre.toUpperCase())">


                            <input class="checkbox__input" type="checkbox" v-model="filtre.values" :value="val.value"/>
                            <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                              <rect width="21" height="21" x=".5" y=".5" fill="#FFF" stroke="#3783C5" rx="3" />
                              <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                            </svg>
                            <span class="checkbox__label">{{val.name}}</span>
                                  </div>
                          </label>

                      </div>
                      <div class="flexBottom">
                          <button type="button" @click="apply_filter()" class="btn" name="button">Apply filters</button>
                      </div>

                    </div>

                    </div>
                </div>
              </div>


                <div>
                  <div class="vselect_container" >
                    <div class="zone_input">
                      <div class="zone_input_header" @click="showSidePanelBasic = !showSidePanelBasic">
                        <span class="zone_input_name">More filters
                          <small class="nb_item" v-if="basicFilters.filter(obj => ((Array.isArray(obj.values) && obj.values.length > 0) || (obj.values.min > 0 || obj.values.max > 0))).length  > 0">{{basicFilters.filter(obj => ((Array.isArray(obj.values) && obj.values.length > 0) || (obj.values.min > 0 || obj.values.max > 0))).length  }}</small>

                          <img :src="require('@/assets/triangle.svg')" class="triangle" :class='(showSidePanelBasic == true) ? "open" : "not-open"' alt="">

                        </span>
                      </div>


                      </div>
                  </div>


              </div>
              <button type="button" @click="reset_bfilter()" class="btn_vide" name="button">Reset</button>


        </div>
        <div class="" >
          <button type="button" class="selectAll" @click="selectAll" v-if='allSelect == false' name="button">Select All</button>
          <button type="button" class="selectAll" @click="unselectAll" v-if='allSelect == true' name="button">Unselect All</button>

        </div>
                  </div>
              </div> -->
            </div>
        </div>
          <div class="col-12 startup_selection_section mt30">
            <div class="loaderInnopearl mt50" v-if="loading">
              <div class="loaderInnopearlInner">
                <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
                <span>Loading in progress</span>
              </div>

            </div>
            <div class="" v-else>

              <div class="" v-if="startups">
                <div class="new_action_zone">
                    <div class="row">
                      <span class="numberOfStartupResult">
                        <strong>{{startups_quicksearch.length}}</strong>/{{total_match}} innovator<span v-if="startups_quicksearch.length > 1">s loaded</span>
                      </span>
                    </div>
                    <div class=" flexItCenterButtons">
                      <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                        <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="runassessment = true" :disabled="are_selected.length == 0">Add to assessment </button>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 1">Please select at least 1 innovator</span>
                        </span>
                      </div>
                      <div class="zoneBtn" :class="(are_selected.length != 2 && are_selected.length != 3) ? 'enableWhyDisabled' :'ok' ">
                        <router-link class="action_btn_pool"  :class="(are_selected.length != 2 && are_selected.length != 3) ? 'disabledRlink' :'ok' " :to="'/compare_startup_to_assess/'+this.$route.params.search_field+'/'+are_selected[0]+'/'+are_selected[1]+'/'+are_selected[2]">Compare</router-link>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 2">Please select at least 2 innovators</span>
                          <span v-if="are_selected.length > 3">You can compare 3 innovators max</span>
                        </span>
                      </div>
                      <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                        <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="dialoglist = true" :disabled="are_selected.length == 0">Add to a list</button>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 1">Please select at least 1 innovator</span>
                        </span>
                      </div>
                      <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                        <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="dialogCreateList = true" :disabled="are_selected.length == 0">Create a new list</button>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 1">Please select at least 1 innovator</span>
                        </span>
                      </div>
                      <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                        <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="dialogRemove = true" :disabled="are_selected.length == 0">Remove</button>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 1">Please select at least 1 innovator</span>
                        </span>
                      </div>
                      <div class="zoneBtn">
                        <button type="button" class="selectAllCp" @click="selectAll" v-if='allSelect == false' name="button">Select All</button>

                        <button type="button" class="selectAllCp" @click="unselectAll" v-if='allSelect == true' name="button">Unselect All</button>
                      </div>
                    </div>
                </div>
                 <!-- <div class="col-12 action_zone">
                   <span class="actionZoneTitle">CHOOSE YOUR ACTION </span>
                  <div class="goRight">
                    <div class="quicksearch">
                        <input type="text" class="input" placeholder="Search by name"  v-model="quicksearch">
                    </div>
                    <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                      <button type="button" class="action_btn" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="dialoglist = true" :disabled="are_selected.length == 0">Add to an existing list</button>
                      <span class="whyDisabled">
                        <span v-if="are_selected.length < 1">Please select at least 1 startup</span>
                      </span>
                    </div>
                    <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                      <button type="button" class="action_btn" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="dialogCreateList = true" :disabled="are_selected.length == 0">Add to a new list</button>
                      <span class="whyDisabled">
                        <span v-if="are_selected.length < 1">Please select at least 1 startup</span>
                      </span>
                    </div>

                    <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                      <button type="button" class="action_btn" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="dialogRevoke = true" :disabled="are_selected.length == 0">Revoke access</button>
                      <span class="whyDisabled">
                        <span v-if="are_selected.length < 1">Please select at least 1 startup</span>
                      </span>
                    </div>
                    <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                      <button type="button" class="action_btn" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="dialogRemove = true" :disabled="are_selected.length == 0">Remove</button>
                      <span class="whyDisabled">
                        <span v-if="are_selected.length < 1">Please select at least 1 startup</span>
                      </span>
                    </div>
                  </div>

                </div> -->
                <!-- <div class="row  p-rl-50" v-if="startups_quicksearch" >
                  <div class="col-12" style="margin-top:20px;">
                    <small><strong>Results : {{startups_quicksearch.length}} startup<span v-if="startups_quicksearch.length > 1">s</span></strong></small>

                  </div>
                </div> -->
                <div class="row zone p-rl-50"  ref="scrollContainer" @scroll="onScroll">

                  <div class="col-12 zone_startups" >
                    <div class="row" v-if="startups_quicksearch.length > 0">
                      <div class="col-12 col-md-6 col-xl-4 candidate" v-for="(candidate, c) in startups_quicksearch" :key="c">
                        <div class="candidate_card" :class="[(are_selected.includes(candidate._id.$oid)) ? 'isChecked' : 'notChecked' , candidate.isAssess ? 'isAssess' : 'notAssess']">
                          <div class="candidate_card_head">
                            <span class="name">{{candidate.name}}</span>
                            <div class="goRight">
                              <div class="selectIt">
                                <input class="checkbox__input" type="checkbox" v-model="are_selected" :value="candidate._id.$oid"/>
                                <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                                  <rect class="fond" width="21" height="21" x=".5" y=".5" fill="none" stroke="#fff" rx="3" />
                                  <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                                </svg>
                              </div>
                            </div>

                          </div>
                          <div class="candidate_info_content">


                            <StartupCardInner v-if="candidate.company_type?.value?.toUpperCase() == 'STARTUP'" :candidate="candidate" isAdmin='true'/>
                            <NonStartupCardInner v-else :candidate="candidate"  isAdmin='true'/>
                          </div>

                            <div class="website" v-if="candidate.website">
                               <a :href="getHttpsUrl(candidate.website)" target="_blank">{{ getBaseUrl(candidate.website) }}</a>
                            </div>
                          <div class="footer">

                            <router-link :to="'/admin/startup_alt/'+candidate._id.$oid"  v-if="candidate._id" >
                            Details  <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                              <g fill="none" stroke="#4c81c0" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10">
                                <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                              </g>
                            </svg>
                            </router-link>
                          </div>


                              </div>
                      </div>
                      <div class="loaderInnopearl mt50" v-if="loading_small">
                        <div class="loaderInnopearlInner">
                          <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
                          <span>Loading in progress</span>
                        </div>

                      </div>
                    </div>
                    <div v-else>
                      <div class="alert alert-warning">
                          No innovators
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt50 mb50" v-else>
                <div class="alert alert-warning text-center mt50">
                    No innovators available
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="row center pad-50">
          <div class="col-12">
            <button v-if="canGoBack" class="prev_step_btn" @click="gobackrouter()">
              <img :src="require('@/assets/prev.svg')" alt="">
              GO BACK
            </button>
          </div>

        </div>

      </div>
  </div>
</template>
<script>
import api from '@/tools/api';
// import { debounce } from 'lodash';
 //import AddCommentModal from '@/components/modals/addCommentWithList.vue'
 import StartupCardInner from '@/components/StartupCardInner.vue'
 import NonStartupCardInner from '@/components/NonStartupCardInner.vue'



// import {
//   VueCollapsiblePanelGroup,
//   VueCollapsiblePanel,
// } from '@dafcoe/vue-collapsible-panel'
// import '@dafcoe/vue-collapsible-panel/dist/vue-collapsible-panel.css'
  import { toast } from 'vue-sonner'
 //  import LongListUploader from '@/components/LongListUploader.vue'
 //  import NewFilter from '@/components/NewFilter.vue'
 // import AddToListModal from '@/components/modals/addToList.vue'
 import AddToListModal from '@/components/modals/addToListAlt.vue'
 import CreateListModal from '@/components/modals/createListAdmin.vue'
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import countries from '@/assets/flat_countries_db.json';
 import StartupRunAssessment from '@/components/StartupRunAssessment.vue'
export default {
  components: {
    // VueCollapsiblePanelGroup,
    // VueCollapsiblePanel,
    // AddCommentModal,
    // LongListUploader,
    // AddToListModal,
    StartupCardInner,
   NonStartupCardInner,
    CreateListModal,
    AddToListModal,
    StartupRunAssessment,
    ConfirmModal
    // NewFilter
  },
  name: 'StartupsStatsListSpace',
  data() {
    return {
      pageInfo: {
        mainTitle : "Innovators management",
        subTitle : "View and complete innovators' profiles",
      },
      debounceTimer:null,
      total_match:0,
      page: 1, // Track pagination
limit: 100, // Number of items per request
hasMore: true, // If more data is available
      toggle: false,
      loading_small:false,
      quicksearch: "",
      pool: {
        name :"",
        isLongList : false,
      },
          runassessment:false,
      dialoglist:false,
      dialogRevoke:false,
      dialogCreateList: false,
      dialogRemove: false,
      sf: null,
      minscore: 0,
      dict_loaded : false,
      showConfirmDialog: false,
      showNewFilterPannel: false,
      showSidePanelBasic:false,
      isLongList : true,
      matching_search_filtre: "",
      showMatching : false,
      allHigh : false,
      allMedium : false,
      allLow : false,
      allSelect: false,
      sfname: "",
      dialog :false,
      dialogList: false,
      startups : null,
      filtres: [],
      selected_filters: [],
      to_compare: [],
      to_assess: [],
      are_selected: [],
      isAssess:false,
      candidateForComments: null,
      loading : false,
      basicFilters : [
            {
                "key": "funding_stage",
                "values": [],
                "values_list" :[],
                "display_name" : "Funding Stage",
                toggled: false,
                toggled_sidebar: false,
                filtre:""
            },
            {
                "key": "development_stage",
                "values": [],
                "values_list" :[],
                "display_name" : "Development stage",
                toggled: false,
                toggled_sidebar: false,
                filtre:""
            },
            {
                "key": "business_model",
                "values": [],
                "values_list" :[],
                "display_name" : "Business model",
                toggled: false,
                toggled_sidebar: false,
                filtre:""
            },
            {
                "key": "company_type",
                "dict": "company_type",
                "values": [],
                "values_list": [],
                "display_name": "Company type",
                toggled: false,
                toggled_sidebar: false,
                filtre: ""
            },
            {
                "key": "data_available",
                "dict": "data_available",
                "values": [],
                "values_list": [],
                "display_name": "Data available",
                toggled: false,
                toggled_sidebar: false,
                filtre:""
            },
            {
                "key": "linkplus",
                "values": [],
                "values_list" :[],
                "display_name" : "Link+",
                toggled: false,
                toggled_sidebar: false,
                filtre:""
            },
            {
                "key": "IP",
                "values": [],
                "dict" : "ip",
                "values_list" :[],
                "display_name" : "IP",
                toggled: false,
                toggled_sidebar: false,
                filtre:""
            },
            {
                "key": "product_category",
                "values": [],
                "values_list" :[],
                "display_name" : "Innovation category",
                toggled: false,
                toggled_sidebar: false,
                filtre:""
            },
            {
                "key": "innovation_area",
                "dict" :"innovation_areas",
                "values": [],
                "values_list" :[],
                "display_name" : "Innovation area",
                toggled: false,
                toggled_sidebar: false,
                filtre:""
            },
            {
                "key": "application_area",
                "dict" :"application_areas",
                "values": [],
                "values_list" :[],
                "display_name" : "Application domain",
                toggled: false,
                toggled_sidebar: false,
                filtre:""
            },
            {
                "key": "markets",
                "values": [],
                "values_list" :[],
                "display_name" : "Markets",
                toggled: false,
                toggled_sidebar: false,
                filtre:""
            },
            {
                "key": "skills",
                "values": [],
                "values_list" :[],
                "display_name" : "Core capabilities",
                toggled: false,
                toggled_sidebar: false,
                filtre:""
            },
            // {
            //     "key": "assets",
            //     "values": [],
            //     "dict" : "type_of_assets",
            //     "values_list" :[],
            //     "display_name" : "Assets",
            //     toggled: false,
            //     toggled_sidebar: false,
            //     filtre:""
            // },
            {
                "key": "sustainability_impact",
                "values": [],
                "dict" : "sustainability_impact",
                "values_list" :[],
                "display_name" : "Sustainability impact",
                toggled: false,
                toggled_sidebar: false,
                filtre:""
            },
            // {
            //     "key": "key_benefits",
            //     "values": [],
            //     "values_list" :[],
            //     "display_name" : "Key benefits",
            //     toggled: false,
            //     filtre:""
            // },
            {
              "key":"revenue",
              "display_name":"Revenue",
              "values": {
                "min": 0,
                "max" : 0,
                "unit": "M",
                "devise": "EUR"
              },
              toggled_sidebar: false,
            },
            {
                "key": "location",
                "values": [],
                "values_list" :countries,
                "display_name" : "Location",
                toggled: false,
                toggled_sidebar: false,
                filtre:""
            },
            {
              "key":"submitDate",
              "display_name":"Application date",
              "values": {
                "from": null,
                "to" : null,
              },
              toggled_sidebar: false,
            },
        ]
    }
  },
  computed: {
    canGoBack() {
      // console.log("router");
      // console.log(this.$router.currentRoute.matched);
      // console.log(window.history);
      //return this.$router.history.length > 1;
      if(window.history)
        if(window.history.length > 1)return true;
      return false;

    }
  },
  methods:{
    newInternal(v){
      console.log("newInternal",v);
      var toPost = {
        assessment : v,
        startups : this.are_selected
      }
      api.post(process.env.VUE_APP_API_URL+"/restrict/createAssessmentFromPool",toPost,
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success(this.$t("Innovators are included in the assessment"));
          this.runassessment = false;
      }).catch( (e) => {
        console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

        this.runassessment = false;
      });
    },
newInnopearl(v){
  console.log(v);
  v.startups = this.are_selected;
  api.post(process.env.VUE_APP_API_URL+"/restrict/new_innopearl_assessment",v,
      {
        headers: {
            'Content-Type': 'application/json',
      }
    }).then( (r) => {
      console.log(r.data);
      toast.success("New assessment have been asked to Innopearl Team");
          this.runassessment = false;
          this.addeddInnoAssess = true;
    }).catch( (e) => {
      console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
    });

},
existingInternal(v){
  console.log("existingInternal",v);
  var toPost = {
    assessment : v,
    startups : this.are_selected
  }
  api.post(process.env.VUE_APP_API_URL+"/restrict/addMultipleStartupsToAssessment",toPost,
      {
        headers: {
            'Content-Type': 'application/json',
      }
    }).then( (r) => {
      console.log(r);
      toast.success(this.$t("Innovators are included in the assessment"));
      this.runassessment = false;
  }).catch( (e) => {
    console.log(e);
      toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

    this.runassessment = false;
  });
},
    createList(v){
      console.log(v);
      v.candidates = this.are_selected;
      api.post(process.env.VUE_APP_API_URL+"/restrict/admin_create_list",v,
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("List successfully created with selected innovators");
          this.dialogCreateList = false;
      }).catch( (e) => {
        console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

        this.dialogCreateList = false;
      });
    },
    getHttpsUrl(url){
      var f = url;
      if (!url.startsWith("https://")  && !url.startsWith("htts://") ) {
                  f = "https://" + url;
              }
              return f;
    },
    getBaseUrl(url){
      var formated = url.replace(/^https?:\/\//, '').replace(/\/$/, '');
      try{
        var r= new URL(url).origin;
        r = r.replace(/^https?:\/\//, '').replace(/\/$/, '');
        return r;
      }catch{
        return formated;
      }
    },

    refreshFilters(d){
      console.log("TOTO",d);
      this.showNewFilterPannel = false;
      // api.get(process.env.VUE_APP_API_URL+"/restrict/my_filters").then( (r) =>{
      //   this.filtres = r.data;
      // });
      if(d){
        this.filtres.push(d);
        this.selected_filters.push(d._id.$oid);
        this.apply_filter();
      }

    },
    reset_bfilter(){
      this.basicFilters.forEach((item) => {
        if(item.key != "revenue" && item.key != "submitDate"){
          item.values = [];
        }
        else{
          if(item.key == "revenue"){
            item.values = {
              "min": 0,
              "max" : 0,
              "unit": "K",
              "devise": "EUR"
            };
          }
          if(item.key == "submitDate"){
            item.values = {
              "from": null,
              "to" : null,
            };
          }

        }

      });
      this.apply_filter();
    },
    toggleFilter(fk){
      console.log(fk);
      this.basicFilters = this.basicFilters.map(obj => ({
        ...obj,
        toggled: (obj.key == fk )? !obj.toggled : false
      }));
      console.log(this.basicFilters);
    },
    apply_filter(){
      this.basicFilters = this.basicFilters.map(obj => ({
        ...obj,
        toggled: false,
        toggled_sidebar: false
      }));
      this.page = 1;
      this.hasMore = true;
      this.limit = 100;
      this.showMatching = false;
      this.showSidePanelBasic = false;
      console.log("BASIC FILTER",this.basicFilters);
      this.loading = true;
      api.post(process.env.VUE_APP_API_URL+"/restrict/basic_filter_from_nothing_foradmin",
          {
            page: this.page,
            limit: this.limit,
            quicksearch:this.quicksearch,
              basicFilters : this.basicFilters,
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
        console.log("POOLFILTERED",r.data);
        this.startups = r.data.startups;
        this.total_match = r.data.total_match;
        this.startups_quicksearch = r.data.startups;
        this.page++;
        if(r.data.startups.length < this.limit)this.hasMore = false; // No more data to load
        this.loading = false;
      }).catch( (e) => {console.log(e);this.loading = false;});
    },
    revokeAccess(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/revoke_access",
            {
              candidates : this.are_selected,
            },
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( () => {
            toast.success("Access successfully revoked");
          }).catch( () => {
              toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
      }

        this.dialogRevoke =false;
    },
    removeStartup(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/remove_startup",
            {
              candidates : this.are_selected,
            },
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( () => {
            toast.success("Access successfully removed");
            this.apply_filter();
          }).catch( () => {
              toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
      }

        this.dialogRemove =false;
    },
    toExisting(v){
      api.post(process.env.VUE_APP_API_URL+"/restrict/add_startup_to_list_multiple",
          {
            poolids : v,
            candidates : this.are_selected,
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( () => {
          toast.success("Innovators successfully added to list");
        }).catch( () => {
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
        this.dialoglist =false;
    },

    selectAll(){
      this.startups.forEach((item) => {
        this.are_selected.push(item._id.$oid);
      });
      this.allSelect = true;
    },
    unselectAll(){
      this.are_selected = [];
      this.allSelect = false;
    },

    gobackrouter : function(){
      this.$router.go(-1);
    },
    async loadStartups() {
     if (this.loading_small || !this.hasMore) return; // Prevent duplicate requests
     this.loading_small = true;

     try {
       const response = await api.post(process.env.VUE_APP_API_URL+'/restrict/basic_filter_from_nothing_foradmin', {
         page: this.page,
         limit: this.limit,
         basicFilters : this.basicFilters,
         quicksearch : this.quicksearch,
       });

       if (response.data.startups.length > 0) {
         this.startups_quicksearch = [...this.startups_quicksearch, ...response.data.startups]; // Append new data
         this.total_match = response.data.total_match;
         this.page++; // Increment page for next request
       } else {
         this.hasMore = false; // No more data to load
       }
     } catch (error) {
       console.error('Error loading innovators:', error);
     }

     this.loading_small = false;
   },

   onScroll() {
     const scrollContainer = document.documentElement;
     if (scrollContainer.scrollHeight - scrollContainer.scrollTop <= scrollContainer.clientHeight + 100) {
       this.loadStartups(); // Load more data when reaching bottom
     }
   }

  },
  mounted(){
         this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
    this.sf = this.$route.params.search_field;
 window.addEventListener('scroll', this.onScroll); // Detect scrolling
    this.dict_loaded = false;
    // if(localStorage.getItem('currentFilterSet')){
    //   var fromCookie = JSON.parse(localStorage.getItem('currentFilterSet'));
    //   this.selected_filters = fromCookie;
    // }
    var requestarray = this.basicFilters.filter(obj => ['revenue', 'location','submitDate'].every(key => obj.key !== key));

    requestarray.forEach((item, index) => {

      var dict_key = (item.dict) ? item.dict : item.key;
      if(dict_key != 'location' && dict_key != "revenue" && dict_key != "linkplus"  && dict_key != "submitDate"){
        api.get(process.env.VUE_APP_API_URL+"/restrict/dict/dict_"+dict_key,{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r.data);
          item.values_list = r.data;
          if(index == requestarray.length - 1){
            console.log("Dict loaded");

          }

        }).catch( error => {
          if(error.response.data.message) toast.error(error.response.data.message);
          else toast.error("Sorry, an error occurs. Please try again !");
        })
      }
      if(dict_key == "linkplus"){
        api.get(process.env.VUE_APP_API_URL+"/restrict/list_mylinkplus").then( (r) => {
          // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
          // console.log();
          // var temp = _.merge(this.candidatespool, r.data)
          console.log("FILTERS");
          console.log(r.data);
          item.values_list = r.data;


        }).catch( (e) => {
          console.log(e);
           toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });
      }
    this.dict_loaded = true;
    });



    if(localStorage.getItem('currentBasicFilterSetAdmin')){
      var fromCookie_2 = JSON.parse(localStorage.getItem('currentBasicFilterSetAdmin'));
      console.log("cookie",fromCookie_2);
      let updatedArrayA = this.basicFilters.map(objA => {
        let matchingObjB = fromCookie_2.find(objB => objB.key === objA.key);

        if (matchingObjB && matchingObjB["values"]) {
          objA.values = matchingObjB["values"];
        }

        return objA;
      });
      this.basicFilters = updatedArrayA;
            this.dict_loaded = true;
      console.log("set filter",this.basicFilters);
    }
    this.loading = true;
       api.post(process.env.VUE_APP_API_URL+"/restrict/basic_filter_from_nothing_foradmin",
           {
               basicFilters : this.basicFilters,
               page: this.page,
               limit: this.limit,
           },
           {
             headers: {
                 'Content-Type': 'application/json',
           }
         }).then( (r) => {
         console.log('callback',r.data);
         this.startups = r.data.startups;
         this.total_match = r.data.total_match;
         this.startups_quicksearch = this.startups;
         this.loading = false;
       }).catch( (e) => {console.log(e);this.loading = false;});




  },
  watch: {
     selected_filters: function (v) {
       // Set the value in a cookie every time the variable changes
       localStorage.setItem('currentFilterSet', JSON.stringify(v));
     },
     basicFilters: {
        handler: function (v) {

          if(this.dict_loaded){
              console.log("Watched value",v);
              localStorage.setItem('currentBasicFilterSetAdmin', JSON.stringify(v));
          }

       },
       deep: true,
     },
     showSidePanelBasic: function(){
       this.basicFilters = this.basicFilters.map(obj => ({
         ...obj,
         toggled: false
       }));
     },
    //  quicksearch: function(v){
    //   console.log(v);
    //   this.startups_quicksearch = this.startups.filter(obj =>
    //     obj.name.toString().toLowerCase().includes(v.toLowerCase())
    //   );
    // },
    quicksearch(v) {
      console.log(v);
      clearTimeout(this.debounceTimer); // Clear existing timer
      this.debounceTimer = setTimeout(() => {
        this.page =1;
        this.apply_filter();
      }, 1000); // Delay of 1.5 seconds
    }
     // minscore : function(v){
     //   console.log(v);
     //   this.apply_filter();
     //
     // }

   },

}
</script>
<style scoped>

.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding-left:0 !important;
  padding-right: 0 !important;
  padding-top:50px;
  padding-bottom:50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}
.chart-container {
  position: relative;
}

.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}

.prev_step_btn,
.prev_step_btn:hover{
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.canvasjs-chart-credit{
  display:none;
}

.mt50{
  margin-top:50px;
}
.mb50{
  margin-bottom: 50px;
}
.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.clickable{
  cursor:pointer;
}
.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}

.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}


.titre{
  margin-bottom: 20px;
  color: #3783C5;
  text-transform: uppercase;
}


.checkbox {
  cursor: pointer;
  display: flex;
  align-items: center;
  /* margin-bottom:20px; */
}
.checkboxItem{
  margin-bottom: 20px;
}
.checkbox__input {
  position: absolute;
  width: 1.375em;
  height: 1.375em;
  opacity: 0;
  cursor: pointer;
}
.checkbox__input:checked + .checkbox__icon .tick {
  stroke-dashoffset: 0;
}
.checkbox__icon {
  width: 1.375em;
  height: 1.375em;
  flex-shrink: 0;
  overflow: visible;
}
.checkbox__icon .tick {
  stroke-dasharray: 20px;
  stroke-dashoffset: 20px;
  transition: stroke-dashoffset 0.2s ease-out;
}
.checkbox__label {
  margin-left: 0.5em;
}

.filtres{

  padding:0;
}
.filtres_head .customH2{
  display: block;
  width: 100%;
  background: #3783C5;
  color: #FFF;
  padding: 10px;
}
.filtre_list{
  padding:10px;
}


.prev_step_btn_small{
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 5px 20px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.next_step_btn_small, .next_step_btn_small:hover {
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 200px;
  opacity: 1;
  padding: 5px 20px;
  color: #FFF;
  margin: auto;
  display:block;
  margin-top:20px;
  margin-bottom: 20px;
}
.startup_zone_legend{
  align-self: top;
}
.zone_startups{
    align-self: center;
}
.zone_title{
  font-size: 25px;
  color: #3783C5;
  font-weight: 700;
  text-align: center;
  display:block;
  width:100%;
  text-align:center;

}
.zone_number{
  font-size: 16px;
  color: #3783C5;
  font-weight: 700;
  text-align: center;
  display:block;
  width:100%;
  text-align:center;

}

.row.zone{
  padding-bottom: 50px;
  padding-top:25px;
}

.startup_zone_legend.stickit .legend{
  position: sticky;
    top: 50%; /* Adjust the top value as needed */
}

.startup_zone_legend:not(.stickit){
  align-self: center;
}

.alert{
  margin:0;
}



.startup_selection_section{
  position:relative;
}

.filtre_list{
  display: grid;
    grid-template-columns: auto auto auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-rows: 100%;
    gap:10px;
}

.pad-50{
  padding-left:50px;
  padding-right:50px;
}
@media screen and (max-width: 690px){
  .candidate_card .candidate_links{
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px
  }
  .candidate_pool{
      padding: 20px;
    }
    .candidate_card .candidate_links .details{
      border-right: none;
      border-bottom:1px solid #DDD;
      padding-bottom: 20px;
    }
    .candidate_card .candidate_links .selectIt label{
    display:flex;
    align-items: center;
    gap: 5px;
    justify-content: start;
    flex-direction: row-reverse;
    }
    .filtre_list {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-rows: 100%;
  gap: 10px;
}
}


.candidate_comments{
  padding: 20px 50px;
  border-top: 1px solid #DDD;
  margin-top:auto;
}
.candidate_comments .one_comment{
  margin-top:10px;
  margin-bottom: 10px;
  font-size:12px;
  line-height:15px;
    position:relative;
}
.candidate_comments .one_comment:after {
  content: ""; /* This is necessary for the pseudo element to work. */
     display: block; /* This will put the pseudo element on its own line. */
     margin: 0 ; /* This will center the border. */
     width: 20%; /* Change this to whatever width you want. */
     padding-top: 10px; /* This creates some space between the element and the border. */

     border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
}
.candidate_comments small{
  font-size:12px;
}

.add_new_comment{
  font-size:12px;
  line-height:15px;
  color: #3785C5;
  text-transform: uppercase;
  margin-top:20px;
}
.add_new_comment img{
  width: 20px;
  margin-right: 10px;
}


.all_candidates_download_zone{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
margin-bottom:50px;
}


.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
margin-bottom: 10px;
}


.all_candidates_download_zone .title{

  font-size: 20px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
margin-bottom: 10px;
font-weight:500;
cursor : pointer;
}


.all_candidates_download_zone .description{
  display:block;
  margin-top:10px;
  margin-bottom: 20px;
  width:100%;
}
.all_candidates_download_zone a{
  color:#B38D2F !important;
}

.next_step_btn{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
.next_step_btn img.left{
  margin-right:10px;
}
img.goFullWhite{
filter: brightness(0) invert(1);
}

.pool_subtitle{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
display:block;
}
.mb10{
  margin-bottom:10px;
}
.mt20{
  margin-top:20px;
}


/* .selectAll{
  border: 1px solid #CCC;
  border-radius: 200px;
  padding: 5px 20px;
  margin: auto;
    margin-top: auto;
  display: block;
  margin-top: 20px;
} */
.goToRight{

}

.candidate_card_head{
  background: transparent linear-gradient(270deg, #3783C5 0%, #1368B2 100%) 0% 0% no-repeat padding-box;

  padding: 10px;
  color: #FFF;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 10px 10px 0px 0px;
  display:flex;
  align-content: center;
    align-items: center;
gap:10px;
min-height: 60px;
}

.candidate_card_head .name{
  flex:1;
}
.score {
  height: 70px;
  width: 70px;
  -webkit-clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  text-align: center;
  background: #B38D2F;
  color: white;
  font-size:17px;
}

.score::before {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  content: '';
}
.candidate_card .candidate_info_content{
  padding:20px;
  flex-grow: 1;
}
.footer{
padding-left: 20px;
  padding-right: 20px;
    padding-bottom: 10px;
  font-weight:bold;
  text-transform: uppercase;
  color:#B38D2F !important;
  font-size:14px;
  display:flex;
  flex-wrap:wrap;
  gap:10px;
}

.footer a{
  margin-left: auto;
}
.footer *{
  color:#4c81c0 !important;
  font-size:14px;
}
.filtre_list .zone_input{
  position:relative;
}
.filter_content{
  position: absolute;
  top: calc(100% + 10px);
  z-index: 900;
  border: 1px solid #4c81c0;
  padding: 20px;
  display:flex;
  flex-direction: column;
  width:400px;
  gap:15px;
  background: #FFF;
  left: calc(50% - 200px);
  box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
-webkit-box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
-moz-box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
}

@media screen and (max-width:990px){
  .filter_content{
    left:-20px;
    right:-20px;
    width:350px;
}
}

.filter_content .value_possible{
  max-height:300px;
  overflow: scroll;
}
.filter_content .btn_invert{
  padding:10px;
  color:#4c81c0;
  background:#FFF;
  font-size:12px;
  border-radius: 20px;
  border:1px solid #4C81C0;
}

.filter_content .btn{
  padding:10px;
  background:#4c81c0;
  color:#FFF;
  font-size:12px;
  border-radius: 20px;
    border:1px solid #4C81C0;
}
.filter_content .flexBottom{
  display: flex;
    gap: 10px;
    flex-wrap: wrap;
align-self: end;
  margin-top:auto;
  align-items: center;
  width:100%;
}
.zone_input_header{
  border: 2px solid #4c81c0;
  padding: 10px;
  border-radius: 200px;
  cursor:pointer;
}
.zone_input{
  width:100% !important;
  position:relative;
}


.filtre_list_3{
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
  border-left: 2px solid #CCC;
  padding-left: 20px;
}
.filtre_list_2{
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
  /* justify-content: center;*/
  align-items: center;
  flex-grow:1;
}

.nb_item{
  background: #B38D2F;
  padding: 2px 10px;
  border-radius: 5px;
  font-size: 10px;
  color:#FFF;
  vertical-align: middle;
  margin-right: 5px;
}
.dflex{
  display: flex;
  gap: 10px;
justify-content: stretch;
}

.checkbox{
  position:relative;
}
.checkbox_hover{
  background:#FFF;
  font-size:10px;
  display:none;
}

.checkboxItem:hover  .checkbox_hover{
  display:block;
}
.onecondition{
  width:100%;
  display:block;
}

.website{
  color:#4c81c0 !important;
  font-size:14px;
  text-align:center;
  margin-bottom:20px;
  font-weight:700;
}
.website a{
  color:#4c81c0 !important;
}
.showComments{
  cursor:pointer;
  position:relative;
}

.showComments img{
  width:30px;
}
.sidePannel{
  position: fixed;
  right: 0;
  width: min(100%,500px);
  background: #FFF;
  top: 0;
  height: 100vh;
  z-index: 999;
  overflow: scroll;

}

.oneFilter{
  padding-top: 20px;
  padding-bottom: 20px;
}
.oneFilter:not(:last-child){
border-bottom: 1px solid #ddd;
}
.oneFilter .filtreName{
  margin-bottom:10px;
  display:block;
  color:#4c81c0;
}
.oneFilter .value_possible{
  max-height:300px;
  overflow: scroll; /* Always show both horizontal and vertical scrollbar */
    scrollbar-width: thin; /* Firefox */
    scrollbar-color: #333 #fff; /* Firefox */
}

.oneFilter .value_possible::-webkit-scrollbar {
      width: 12px; /* Width of the scrollbar */
    }

.oneFilter .value_possible::-webkit-scrollbar-thumb {
      background-color: #333; /* Color of the thumb */
    }
.oneFilter .value_possible::-webkit-scrollbar-track {
      background-color: #fff; /* Color of the track */
    }

    .sidePannel .filters{
      overflow: scroll;
  padding: 30px;
  height: calc(100vh - 100px);
    }

  .sidePannel .create_filters{
    overflow: scroll;
padding: 30px;
height: calc(100vh);
  }
    .footerPannel{
      position: static;
  height: 100px;
  border-top: 2px solid #4c81c0;
  padding:20px;
  text-align:right;
    }

      .footerPannel .btn{
      padding:5px 10px;
      background:#4c81c0;
      color:#FFF;
      font-size:15px;
      border-radius: 20px;
      border:1px solid #4C81C0;
      margin:10px;
    }

    .footerPannel .btn_invert{
    padding:5px 10px;
    color:#4c81c0;
    background:#FFF;
    font-size:15px;
    border-radius: 20px;
    border:1px solid #4C81C0;
    margin:10px;
  }
  .triangle{
    width:15px;
  }

  .triangle.open{
    transform:rotate(180deg);
  }

  .candidate_card.isChecked{
    border-color:#4C81C0;
  }
  .candidate_card.isChecked .checkbox__icon .fond{
    fill:#FFF !important;
  }

  /* .candidate_card.isAssess{
    border-color:#ad8e41;
  } */
  /* .candidate_card.isAssess .candidate_card_head{
    background:#ad8e41;
  } */
.goRight{
  margin-left:auto;
  display:flex;
  flex-wrap:wrap;
  gap:20px;
}
.extraPoolsContainer{
  position:relative;
}
.extraPoolsIcons{
  width:20px;
}
.extraPoolsNumber{
  background: #B38D2F;
  color: #FFF;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}

.isAssess .extraPoolsNumber{
  color: #B38D2F;
  background: #FFF;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}
.nb_item_comments{
  background: #B38D2F;
  color: #FFF !important;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}

.action_zone{
  position: sticky;
    right: 0;
    top: 0;
    background: #4C81C0;
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;

}

.actionZoneTitle{
  color: #FFF;
  font-weight: bold;
  font-size: 20px;
    text-transform: uppercase;
}

.p-rl-50{
  padding-left:50px;
  padding-right:50px;
}

.action_btn,
.action_btn:hover{
  background: #FFF;
  color: #000;
  padding: 5px 15px;
  font-weight: 600;
  border-radius: 200px;
}
.back_btn,
.back_btn:hover{
  background: #FFF;
  color: #000;
  padding: 10px 25px;
  font-weight: 400;
  border-radius: 200px;
}



.whyDisabled{
  position: absolute;
  background: #EFEFEF;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.enableWhyDisabled:hover .whyDisabled{
  display:block;
}

.hoverInfo{
  position: absolute;
  background: #EFEFEF;
  color:#000 !important;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.extraPoolsContainer:hover .hoverInfo{
  display:block;
}

.filter_content_title{
  text-transform:uppercase;
  font-weight:600;
}

.v-slider-track__background--opacity {
  opacity: 1;
}



[data-tooltip] {
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  position: relative;
  margin-right: auto;
}
[data-tooltip]::after {
  background-color: rgba(51, 51, 51, 0.9);
  border-radius: 0.3rem;
  color: #fff;
  content: attr(data-tooltip);
  font-size: 1rem;
  font-size: 85%;
  font-weight: normal;
  line-height: 1.15rem;
  opacity: 0;
  padding: 0.25rem 0.5rem;
  position: absolute;
  text-align: center;
  text-transform: none;
  transition: opacity 0.2s;
  visibility: hidden;
  white-space: nowrap;
  z-index: 1;
}
[data-tooltip].tooltip-top::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: rgba(51, 51, 51, 0.9) transparent transparent transparent;
  top: 0;
  left: 50%;
  margin-left: -0.3rem;
}
[data-tooltip].tooltip-top::after {
  bottom: 100%;
  left: 50%;
  transform: translate(-50%);
}
[data-tooltip].tooltip-bottom::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent transparent rgba(51, 51, 51, 0.9) transparent;
  bottom: 0;
  left: 50%;
  margin-left: -0.3rem;
}
[data-tooltip].tooltip-bottom::after {
  top: 100%;
  left: 50%;
  transform: translate(-50%);
}
[data-tooltip].tooltip-left::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent transparent transparent rgba(51, 51, 51, 0.9);
  top: 0.3rem;
  right: calc(110% - 0.3rem);
  margin-top: -0.3rem;
}
[data-tooltip].tooltip-left::after {
  top: -0.3rem;
  right: calc(110% + 0.3rem);
}
[data-tooltip].tooltip-right::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent rgba(51, 51, 51, 0.9) transparent transparent;
  top: 50%;
  top: 0.3rem;
  left: calc(110% - 0.3rem);
  margin-top: -0.3rem;
}
[data-tooltip].tooltip-right::after {
  top: -0.3rem;
  left: calc(110% + 0.3rem);
}
@media (max-width: 767px) {
  [data-tooltip].tooltip-mobile::before {
    display: none;
  }
  [data-tooltip].tooltip-mobile:after {
    font-size: 1rem;
    max-width: 20rem;
    position: fixed;
    bottom: auto;
    top: 50%;
    left: 50%;
    text-align: left;
    transform: translate(-50%);
    white-space: normal;
  }
}
[data-tooltip]:hover::after, [data-tooltip][class*=tooltip-]:hover::before {
  visibility: visible;
  opacity: 1;
}

.poolTitle .customH2{
  color:#B38D2F;
}

.poolTitle .customH2 .sfname{
  font-weight: 700;
  text-transform:uppercase;
}


.slider_mini_score{
  max-width: 350px;
  min-width: 300px;
}

.moneyEntryLine{
  width: 100%;

}
.moneyEntryName{
    color:#333;
}
.moneyEntryInput{
  flex:1;

}

.moneyEntryLine select{
  -moz-appearance: menulist;
  -webkit-appearance: menulist;
}

.m-rlb-50{
  margin-left: 50px;
  margin-right: 50px;
  margin-bottom: 50px;
}

.flexIt > div{
  display:flex;
}
.mlauto{
  margin-left: auto;
}
.numberRes{
  font-weight: 400;
  color:#3783c5;
}
@media screen and (min-width:1301px) and (max-width:1650px){
  .candidate {
    flex: 0 0 auto;
    width: calc(100% / 3);
  }

}
@media screen and (min-width:1000px) and (max-width:1300px){
  .candidate {
    flex: 0 0 auto;
    width: 50%;
  }

}



  .quicksearch{
    position:relative;
  }
  .quicksearch .input{
    max-width:300px;
      border: 1px solid #3783C5;
      background: transparent;
      padding: 10px 20px;
      padding-right: 50px;
      border-radius: 200px;
      outline: none;
      color: #3783C5;
      font-weight: bold;
      letter-spacing: 1px;
  }
  .quicksearch::after{
    content: url('@/assets/loupe.svg');
    position:absolute;
    right:15px;
    top:50%;
    transform:translateY(-50%);
  }



  @media screen and (max-width:990px){
    .quicksearch{
      max-width: 100%;
      width:100%;
      margin-top:20px;
      margin-bottom:20px;
    }
    .quicksearch .input{
      max-width: 100%;
      width:100%;
        /* border: 1px solid #fff;
        background: transparent;
        padding: 5px 20px;
        border-radius: 200px;
        outline: none;
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px; */
    }
    .filtre_list_2{
      width:100%;
      flex:1;
    }

    .target_score_container .slider_mini_score{
      flex-direction: column !important;
    }
    .flexItCenterButtons{
      flex-direction: column;

    }
    .whyDisabled{
      z-index: 9999;
    }
  }

  .mt30{
    margin-top:30px;
  }
  .super_action_zone{
    padding: 20px 30px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;
    background: rgba(55, 131, 197, .07);
  border-radius: 200px;
  margin-right: 20px;
  margin-left: 20px;
  display:flex;
  align-items: center;
  justify-content: space-between;
  }

  @media screen and (max-width:690px){
      .super_action_zone{flex-direction: column;gap:20px;    padding: 10px;}
    .quicksearch{
      margin-top:20px;
    }
    .quicksearch .input{
      max-width: 100%;
      width:100%;

    }
    .filtre_list_2{
      width:100%;
      flex:1;
    }
  }
    .tooglerFilter .toogler{
      color:#3982C4;
      font-weight: 400px;
      display:flex;
      gap:10px;
    }


    .numberOfStartupResult{
      text-align:center;
    font-size: 21px;
    line-height:25px ;
letter-spacing: 0px;
color: rgba(55, 131, 197, 1);
text-transform: uppercase;
    }

    .flexItCenterButtons{
      width:100%;
      display:flex;
      justify-content: center;
      align-items: center;
      gap:10px;
      margin-top:20px;
    }


    .action_btn_pool,
    .action_btn_pool:hover{
      background: rgba(55, 131, 197, 1);
      border:1px solid rgba(55, 131, 197, 1);
      color: #fff ;
      padding: 10px 30px;
      font-weight: 600;
      border-radius: 200px;
      text-transform: uppercase;
      font-size:15px;
    }

    .disabledRlink{
      pointer-events: none;
      opacity: 0.7;
    }
    .selectAllCp{
      color: rgba(179, 141, 47, 1);
      border:1px solid rgba(179, 141, 47, 1);
      background: #fff ;
      padding: 10px 30px;
      font-weight: 600;
      border-radius: 200px;
      text-transform: uppercase;
      font-size:15px;
      margin-top:0px;
    }


    .zoneBtn{
      position:relative;
      display: flex;
    width:auto;

    }

    .candidate_card.isChecked{
      border-color:#4C81C0;
    }
    .candidate_card.isChecked .checkbox__icon .fond{
      fill:transparent !important;
    }
    .candidate_card:not(.whitehead).isChecked .checkbox__icon .tick{
      stroke:#FFF !important;
    }

    .detail{
      background: #F1F6FB;
  padding: 10px 20px;
  border-radius: 200px;
  text-align: center;
    }
</style>
<style media="screen" >
  .vcp__header{
    background-color:#3783C5 !important;
    color:#FFF !important;
    padding:20px !important;
  }
  .vcp__body {
 border-top: 1px solid #3783C5 !important;
}
.vcpg{
   border: 1px solid #3783C5 !important;
}
  .vcp__header .customH2{
    font-size:20px;
    line-height:20px;
    margin:0;
  }

  .links_2{
    border-top: 1px solid #DDD;
  }
  .input_filtre{
    border: 1px solid #4c81c0;
    width: 100%;
    padding: 5px;
    margin-bottom: 20px;

  }
  .v-slider-track__background--opacity {
    opacity: 1;
  }




</style>
